import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import AuthService from '@/services/authService'

Vue.use(Router)

const router = new Router({
    base: process.env.BASE_URL,
    routes: [{
            path: '/login',
            name: 'login',
            component: () =>
                import ('@/views/Login.vue')
        },
        {
            path: '/actions',
            name: 'actions',
            component: () =>
                import ('@/views/Actions.vue')
        },
        {
            path: '/settings',
            name: 'settings',
            component: () =>
                import ('@/views/Settings.vue'),
            beforeEnter: AuthService.requireAuth
        },
        {
            path: '/',
            name: 'home',
            component: () =>
                import ('@/views/Home.vue'),
            beforeEnter: AuthService.requireAuth
        },
        {
            path: '/create',
            name: 'create',
            component: () =>
                import ('@/views/CreateEditRecipe.vue'),
            beforeEnter: AuthService.requireAuth
        },
        {
            path: '/:recipeId',
            name: 'recipe',
            component: () =>
                import ('@/views/Recipe.vue'),
            beforeEnter: AuthService.requireAuth
        },
        {
            path: '/:recipeId/edit',
            name: 'edit',
            component: () =>
                import ('@/views/CreateEditRecipe.vue'),
            beforeEnter: AuthService.requireAuth
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name == 'login' && store.state.currentUser) {
        next('/')
    } else next()
})

export default router